import React from 'react';
import { Alert, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { requestsActions } from '../../../Requests/requests.actions';

export const ImportFromCityPortalAlertSuccess = ({}) => {
  const dispatch = useDispatch();
  const importResult = useSelector((state) => state.requestsStore.importResult);
  const importResultRequests = useSelector(
    (state) => state.requestsStore.importResultRequests
  );

  if (!importResult?.createdRequestIds?.length) {
    return null;
  }

  const handleLoadImportedRequests = () => {
    dispatch(
      requestsActions.fetchImportResultRequests(importResult.createdRequestIds)
    );
  };

  return (
    <Alert
      onClose={() => {
        const newValue = importResult?.errorFiles?.length
          ? {
              ...importResult,
              createdRequestIds: [],
            }
          : null;
        dispatch(requestsActions.setImportResult(newValue));
      }}
      message={
        <div>
          <div>Заявки созданы массовой загрузкой:</div>
          <div>{importResult.createdRequestIds.join(', ')}</div>
          {!importResultRequests?.length && (
            <div>
              <Button onClick={handleLoadImportedRequests}>Загрузить</Button>
            </div>
          )}
        </div>
      }
      type="success"
      closable
      showIcon={false}
      banner
    />
  );
};
